import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-query-risque-professionnel-sante',
  templateUrl: './query-risque-professionnel-sante.component.html',
  styleUrls: ['./query-risque-professionnel-sante.component.scss']
})
export class QueryRisqueProfessionnelSanteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
